import { CSSProperties, FC } from 'react'

import { Spinner } from '@hap/components'

import Box from '../box'

const AppLoader: FC<{ style?: CSSProperties }> = ({ style }) => {
  return (
    <Box position="fixed" top="50%" left="50%" style={style}>
      <Spinner />
    </Box>
  )
}

export default AppLoader
